<template>
  <div id="app">
    <!-- <div class="top-space"></div>     -->
    <div class="content">
      <!-- sidebar -->
      <SideNavbar></SideNavbar>
      <!-- sidebar -->
      <!-- router-view -->
      <div class="content-area">
        <header>
          <div class="top-space">  
            <div class="navbar-logo-mobile">
                <div class="navbar__logo">
                  <svg viewBox="0 0 31 31"><g fill="#FFFFFF" fill-rule="nonzero"><path d="M0 3h8.696L20 14.55 9.064 29h-7.96l10.81-14.256zM22.162 13L32 3h-8.668L18 8.619zM18 22.323L23.004 29H31l-9.01-12z"></path></g></svg>
                  <span class="logo-text">Media Mentions</span>
                </div>                
            </div>          
          </div>
        </header>
        <router-view></router-view>
        <footer class="footer">© {{ currentYear }} Radix FZC. All Rights Reserved</footer>
      </div>
      <!-- router-view -->
    </div>
  </div>
</template>

<script>
import SideNavbar from './components/SideNavbar.vue'


export default {
  name: 'app',
  components: { 
   SideNavbar,

  },
  data() {
    return {
     currentYear: new Date().getFullYear(),
    }    
  }
}
</script>

<style lang="scss">
  @import "@/assets/sass/style.scss";
  @import "../node_modules/ag-grid-community/dist/styles/ag-grid.css";
  @import "../node_modules/ag-grid-community/dist/styles/ag-theme-material.css";

</style>
